import { Pressable, Text, View } from 'react-native';
import { aplicarAgora, baixarApk, useAtualizacao } from '../lib/atualizacoes';
import { C, alpha } from './theme';
import { t } from '../lib/i18n';

/** Aviso de atualização pronta (automática) ou de versão nova do aplicativo para baixar. */
export function AtualizacaoBanner({ cor }: { cor: string }) {
  const a = useAtualizacao();
  if (a.ota !== 'pronta' && !a.apk) return null;
  const apk = a.ota !== 'pronta' && a.apk;
  return (
    <Pressable onPress={apk ? baixarApk : aplicarAgora}
      style={{ flexDirection: 'row', alignItems: 'center', gap: 12, padding: 12, borderRadius: 14, backgroundColor: alpha(cor, 0.16), borderWidth: 1, borderColor: alpha(cor, 0.5) }}>
      <Text style={{ fontSize: 22 }}>{apk ? '📲' : '✨'}</Text>
      <View style={{ flex: 1 }}>
        <Text style={{ color: C.text, fontWeight: '700' }}>{apk ? t('Versão {versao} disponível', { versao: a.apk!.versao }) : t('Atualização pronta')}</Text>
        <Text style={{ color: C.sub, fontSize: 12 }} numberOfLines={2}>
          {apk ? (a.apk!.notas || t('Toque para baixar e instalar por cima. Seus dados continuam.')) : t('Toque para aplicar agora. Ou ela entra sozinha ao reabrir o app.')}
        </Text>
      </View>
      <Text style={{ color: cor, fontWeight: '800' }}>{apk ? t('Baixar') : t('Aplicar')}</Text>
    </Pressable>
  );
}
